import axios from 'axios';
import { keycloakService } from '@/plugins';
import state from '../store/state';

/*
Change baseURL to suit your project needs.
*/
const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 30000,
});

http.interceptors.request.use((config) => {
  const paramReasign = config;
  paramReasign.headers.authorization = `Bearer ${keycloakService.authToken}`;
  if (state.acceptHeader) {
    paramReasign.headers.accept = state.acceptHeader;
  }
  if (state.boostUrl) {
    paramReasign.baseURL = process.env.VUE_APP_BOOST_API_URL;
  }

  return paramReasign;
}, (error) => Promise.reject(error));

export default http;
